import type { MenuItemV2, NativeMenuItem } from '../../../../types/menuV2';

/**
 * Type guard to check if an item is a native menu item.
 * Native items have 'children' property without 'type' property.
 * Cross-app items have 'type' property (e.g., 'crossAppLink').
 *
 * @param item - The menu item to check
 * @returns True if the item is a native menu item
 */
export const isNativeMenuItem = (item: MenuItemV2): item is NativeMenuItem => {
	return 'children' in item && !('type' in item);
};
